import { Injectable } from '@angular/core';
import { EDGE_ZONE_PX, MAX_SCROLL_SPEED_PX } from '../config/constants';

@Injectable({ providedIn: 'root' })
export class DragAutoScrollService {

  private _scrollContainer: HTMLElement | null = null;
  private _rafId: number | null = null;
  private _lastPointerY = 0;

  public updatePointerY(y: number): void {
    this._lastPointerY = y;
  }

  public start(scrollContainer: HTMLElement | null): void {
    this._scrollContainer = scrollContainer;
    if (!scrollContainer) return;

    const tick = (): void => {
      this._tick();
      this._rafId = requestAnimationFrame(tick);
    };
    this._rafId = requestAnimationFrame(tick);
  }

  public stop(): void {
    if (this._rafId !== null) {
      cancelAnimationFrame(this._rafId);
      this._rafId = null;
    }
    this._scrollContainer = null;
  }

  private _tick(): void {
    const container = this._scrollContainer;
    if (!container) return;

    const rect = container.getBoundingClientRect();
    const cursorY = this._lastPointerY;

    const distanceFromTop = cursorY - rect.top;
    const distanceFromBottom = rect.bottom - cursorY;

    if (distanceFromTop < EDGE_ZONE_PX && distanceFromTop >= 0) {
      const intensity = 1 - distanceFromTop / EDGE_ZONE_PX;
      container.scrollBy({ top: -Math.ceil(intensity * MAX_SCROLL_SPEED_PX) });
      return;
    }

    if (distanceFromBottom < EDGE_ZONE_PX && distanceFromBottom >= 0) {
      const intensity = 1 - distanceFromBottom / EDGE_ZONE_PX;
      container.scrollBy({ top: Math.ceil(intensity * MAX_SCROLL_SPEED_PX) });
    }
  }
}
